import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer" id="contacts">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Организатор</h3>
          <p>
            Организатором Хакатона является Автономная некоммерческая организация детский технопарк 
            «Красноярский Кванториум» при финансовой поддержке Министерства образования Красноярского края.
          </p>
        </div>

        <div className="footer-section">
          <h3>Контакты</h3>
          <div className="contact-item">
            <strong>Адрес:</strong>
            <span>г. Красноярск, ул. Дубровинского, 1и, пом. 15</span>
          </div>
          <div className="contact-item">
            <strong>Телефон:</strong>
            <a href="tel:+73912573797">+7 (391) 257-37-97</a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Поддержка конкурса</h3>
          <div className="contact-item">
            <strong>Email:</strong>
            <a href="mailto:alena.kvantorium.pedorg@yandex.ru?subject=Вопрос по хакатону по нанотехнологиям">
              alena.kvantorium.pedorg@yandex.ru
            </a>
          </div>
          <div className="contact-item">
            <strong>ВКонтакте:</strong>
            <a href="https://vk.com/kvantorium24" target="_blank" rel="noopener noreferrer">
              vk.com/kvantorium24
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 Красноярский Кванториум. Все права защищены.</p>
      </div>
    </footer>
  );
};

export default Footer; 